var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStudentTotal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9835 39.7296C65.7552 26.378 63.8645 -2.68016 39.5976 0.199308C15.3306 3.07877 -0.0020954 36.3266 1.00047 47.8454C2.00303 59.3642 9.52091 80.8311 44.1093 77.6896C78.6976 74.5481 84.2117 53.0812 74.9835 39.7296Z",
    fill: "url(#paint0_linear_13745_17411)",
    fillOpacity: 0.36
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1003 36.8329V38.8277C57.1003 41.3068 55.0905 43.3166 52.6114 43.3166C50.1324 43.3166 48.1227 41.3068 48.1227 38.8277V36.8329L51.2441 38.2202C52.1147 38.6071 53.1083 38.6071 53.9788 38.2202L57.1003 36.8329ZM45.3172 35.586V40.5111C45.3172 40.9761 44.9404 41.3529 44.4754 41.3529C44.0106 41.3529 43.6338 40.9761 43.6338 40.5111V34.8368C43.6441 34.8421 43.6546 34.8471 43.6653 34.8519L45.3172 35.586Z",
    fill: "#821C6B",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.557 34.6546L53.9782 31.2863C53.1076 30.8994 52.114 30.8994 51.2435 31.2863L43.6647 34.6546C43.2205 34.8521 43.2205 35.4826 43.6647 35.6801L51.2435 39.0484C52.114 39.4353 53.1076 39.4353 53.9782 39.0484L61.557 35.6801C62.0013 35.4826 62.0013 34.8521 61.557 34.6546Z",
    fill: "#821C6B",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1724 53.1222H59.3439C60.5836 53.1222 61.5884 52.1175 61.5884 50.8778C61.5884 48.4459 59.3925 46.3543 56.2445 45.4286C55.8687 45.3182 55.4668 45.4369 55.1914 45.7153L53.4088 47.5178C52.9694 47.962 52.2522 47.962 51.8129 47.5178L50.0304 45.7153C49.7548 45.4369 49.3529 45.3182 48.9771 45.4286C47.8743 45.7529 46.8885 46.2203 46.0728 46.7953C48.016 48.5735 49.1645 50.7589 49.1724 53.1222Z",
    fill: "#821C6B",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0048 32.1677V35.2112C40.0048 38.993 36.9389 42.0589 33.157 42.0589C29.3751 42.0589 26.3092 38.993 26.3092 35.2112V32.1677L31.0712 34.2841C32.3991 34.8743 33.9149 34.8743 35.2429 34.2841L40.0048 32.1677ZM22.0293 30.2655V37.779C22.0293 38.4882 21.4545 39.063 20.7454 39.063C20.0363 39.063 19.4614 38.4882 19.4614 37.779V29.1226C19.477 29.1306 19.493 29.1383 19.5094 29.1456L22.0293 30.2655Z",
    fill: "#821C6B",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8035 27.5812L35.2418 22.4427C33.9139 21.8524 32.398 21.8524 31.0701 22.4427L19.5083 27.5812C18.8306 27.8824 18.8306 28.8444 19.5083 29.1456L31.0701 34.2842C32.398 34.8744 33.9139 34.8744 35.2418 34.2842L46.8035 29.1456C47.4813 28.8444 47.4813 27.8824 46.8035 27.5812Z",
    fill: "#821C6B",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2198 44.4555L31.9393 47.2054C32.6094 47.8828 33.7037 47.8828 34.3738 47.2054L37.0933 44.4555C37.5134 44.0308 38.1266 43.8496 38.6999 44.0182C43.5022 45.4304 46.8521 48.6211 46.8521 52.3311C46.8521 54.2221 45.3193 55.755 43.4282 55.755H22.8848C20.9939 55.755 19.4609 54.2221 19.4609 52.3311C19.4609 48.6211 22.811 45.4304 27.6132 44.0182C28.1864 43.8496 28.7997 44.0308 29.2198 44.4555Z",
    fill: "#821C6B",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13745_17411",
    x1: -5.23708,
    y1: 9.63185,
    x2: 81.4697,
    y2: 50.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#821C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#821C6B",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStudentTotal);
export default __webpack_public_path__ + "static/media/ic-student-total.d8e0c8e7a74587a14df1126998267948.svg";
export { ForwardRef as ReactComponent };